import React from 'react';
import { Button } from '@/lib';
import { useTranslation } from 'react-i18next';

type ActionButtonProps = {
  handleBack: VoidFunction;
  handleNext: VoidFunction | (() => Promise<void>) | (() => Promise<boolean>);
  isNextDisabled?: boolean;
  isLoading?: boolean;
};

export const ActionButton = ({ handleBack, handleNext, isNextDisabled = false, isLoading = false }: ActionButtonProps) => {
  const { t } = useTranslation('COMMON');
  return (
    <div className='flex items-center justify-between gap-4'>
      <Button intent='secondary' text={t('back')} onClick={handleBack} />
      <Button className='w-full max-w-[220px]' text={t('next')} onClick={handleNext} disabled={isNextDisabled || isLoading} isLoading={isLoading} />
    </div>
  );
};
